var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"juragan-badge"},[_c('img',{attrs:{"src":"https://storage.googleapis.com/komerce/assets/svg/Saudagar.svg","alt":"Saudagar"}})])}]

export { render, staticRenderFns }